import keyMirror from 'keymirror';

export const reportModalActionTypes = keyMirror({
	TOGGLE_REPORT_MODAL: null,

	GET_REPORT_OPTIONS_REQUEST: null,
	GET_REPORT_OPTIONS_SUCCESS: null,
	GET_REPORT_OPTIONS_ERROR: null,

	SEND_REPORT_REQUEST: null,
	SEND_REPORT_SUCCESS: null,
	SEND_REPORT_ERROR: null,

	SET_REPORT_ITEM_ID: null,
});

export const REPORT_TYPE = keyMirror({
	question: null,
	answer: null,
});
